import script from "./ActionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ActionMenu.vue?vue&type=style&index=0&id=bd0cd0cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd0cd0cc"]])

export default __exports__